import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnChanges } from '@angular/core';

import {
  GraphQLProfile,
  OmguiProfileBubbleModule,
  Profile,
  UserType,
} from '@omgui/omgui-profile-bubble/omgui-profile-bubble.component';

import { ComponentSize } from '../component-size';

@Component({
  selector: 'omgui-multiple-avatar-display',
  templateUrl: 'omgui-multiple-avatar-display.component.html',
  styleUrls: ['omgui-multiple-avatar-display.component.scss'],
})
export class OmguiMultipleAvatarDisplayComponent implements OnChanges {
  /** Limits the number of avatars that will be displayed. Those over the limit will be shown as a summary bubble. */
  @Input() displayedAvatarsMaximum: number;

  /** Contains the name and image data for the bubbles. */
  @Input() providerProfiles: Array<Profile | GraphQLProfile>;

  /** Optional: Total number of providers to display if different length of providerProfiles */
  @Input() totalProviderCount?: number;

  /** Size to render the profile bubbles */
  @Input() size: ComponentSize = ComponentSize.small;

  /** @ignore */
  displayedProfiles: Array<Profile | GraphQLProfile>;
  /** @ignore */
  readonly componentSize = ComponentSize;

  /** @ignore */
  ngOnChanges(): void {
    this.makeBubbleInputs();
  }

  /** @ignore */
  private makeBubbleInputs(): void {
    const displayedProfiles = this.providerProfiles.slice(0, this.displayedAvatarsMaximum);
    this.totalProviderCount = this.totalProviderCount ? this.totalProviderCount : this.providerProfiles.length;
    const hiddenAvatarsCount = this.totalProviderCount - this.displayedAvatarsMaximum;

    if (hiddenAvatarsCount > 0) {
      displayedProfiles.push({
        preferredName: '+',
        lastName: hiddenAvatarsCount.toString(),
        type: UserType.InternalUser,
      });
    }

    this.displayedProfiles = displayedProfiles;
  }
}

@NgModule({
  declarations: [OmguiMultipleAvatarDisplayComponent],
  imports: [CommonModule, OmguiProfileBubbleModule],
  exports: [OmguiMultipleAvatarDisplayComponent],
})
export class OmguiMultipleAvatarDisplayModule {}
